import { useState } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import SubLayers from "./SubLayers";

// * show_tabs: one children table per tab, only the active one is rendered
export default function SubLayerTabs({ tabs, children_layer_type }: { tabs: any[]; children_layer_type?: any }) {
    const [activeIndex, setActiveIndex] = useState(0);
    const active = Math.min(activeIndex, tabs.length - 1);

    return (
        <>
            <Nav tabs className="mb-3">
                {tabs.map((tab, index) => (
                    <NavItem key={index}>
                        <NavLink className={index === active ? "clickable active" : "clickable"} onClick={() => setActiveIndex(index)}>
                            {tab.title || `Tab ${index + 1}`}
                        </NavLink>
                    </NavItem>
                ))}
            </Nav>
            <SubLayers key={active} subconfig={tabs[active]} hideTitle children_layer_type={children_layer_type} />
        </>
    );
}
